module.exports = __webpack_public_path__ + "static/media/company_logo.d6759d5f.png";